<template>
  <router-view />
</template>

<script>
import { useHead } from '@vueuse/head'
import { defaultSEO } from '@/config/seo.js'

export default {
  name: 'App',
  setup() {
    useHead(defaultSEO)
  }
}
</script>

<style lang="scss">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
</style>
